/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailingListDto as FeatureMailingListsMailingListDto } from '../../models/feature/mailing-lists/mailing-list-dto';
import { UpdateMailingListAndRecipientsDto as FeatureMailingListsUpdateMailingListAndRecipientsDto } from '../../models/feature/mailing-lists/update-mailing-list-and-recipients-dto';

export interface UpdateMailingList$Params {
  id: number;
      body: FeatureMailingListsUpdateMailingListAndRecipientsDto
}

export function updateMailingList(http: HttpClient, rootUrl: string, params: UpdateMailingList$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureMailingListsMailingListDto>> {
  const rb = new RequestBuilder(rootUrl, updateMailingList.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureMailingListsMailingListDto>;
    })
  );
}

updateMailingList.PATH = '/edit-mailing-list-page/{id}';

